import { render } from "./SelectOrganization.vue?vue&type=template&id=348a0fd4&ts=true"
import script from "./SelectOrganization.ts?vue&type=script&lang=ts&external"
export * from "./SelectOrganization.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__